import(/* webpackMode: "eager" */ "/app/app/nextjs/app/(site)/geo-blocked/page.tsx");
